import {
  REQUEST_FEATURE,
  type MeInfo,
  type OperationCategory,
  type OperationInfo,
} from "./types";

export type NavTabPath = "/" | "/calc" | "/views" | "/report" | "/settings";

/** Админ имеет доступ ко всему; иначе нужен ключ в permissions. */
export function canAccess(
  me: MeInfo | null | undefined,
  featureId: string,
): boolean {
  if (!me) return false;
  return me.is_admin || me.permissions.includes(featureId);
}

export function canAccessRequest(me: MeInfo | null | undefined): boolean {
  return canAccess(me, REQUEST_FEATURE);
}

export function hasCategoryOps(
  operations: OperationInfo[],
  category: OperationCategory,
): boolean {
  return operations.some((op) => op.category === category);
}

/** Пути нижнего меню, доступные текущему пользователю. «Настройки» всегда. */
export function getAccessiblePaths(
  me: MeInfo | null | undefined,
  operations: OperationInfo[],
): NavTabPath[] {
  const paths: NavTabPath[] = [];
  if (canAccessRequest(me)) paths.push("/");
  if (hasCategoryOps(operations, "calc")) paths.push("/calc");
  if (hasCategoryOps(operations, "views")) paths.push("/views");
  if (hasCategoryOps(operations, "report")) paths.push("/report");
  paths.push("/settings");
  return paths;
}

/** Первый доступный раздел — для редиректов с закрытых страниц. */
export function getDefaultPath(
  me: MeInfo | null | undefined,
  operations: OperationInfo[],
): string {
  return getAccessiblePaths(me, operations)[0] ?? "/settings";
}
